import { defineComponent as a, provide as m, inject as c, h as n, Fragment as f } from "vue";
import { useMenuChild as g } from "./ghl-ui.es1371.js";
import { useMenuChildProps as v } from "./ghl-ui.es1372.js";
import { itemRenderer as j } from "./ghl-ui.es1043.js";
import { submenuInjectionKey as y, menuItemGroupInjectionKey as x, menuInjectionKey as C } from "./ghl-ui.es1045.js";
import { render as s } from "./ghl-ui.es985.js";
const N = Object.assign(Object.assign({}, v), {
  tmNode: {
    type: Object,
    required: !0
  },
  tmNodes: {
    type: Array,
    required: !0
  }
}), G = a({
  name: "MenuOptionGroup",
  props: N,
  setup(t) {
    m(y, null);
    const r = g(t);
    m(x, {
      paddingLeftRef: r.paddingLeft
    });
    const {
      mergedClsPrefixRef: l,
      props: i
    } = c(C);
    return function() {
      const {
        value: u
      } = l, d = r.paddingLeft.value, {
        nodeProps: o
      } = i, e = o == null ? void 0 : o(t.tmNode.rawNode);
      return n("div", {
        class: `${u}-menu-item-group`,
        role: "group"
      }, n("div", Object.assign({}, e, {
        class: [`${u}-menu-item-group-title`, e == null ? void 0 : e.class],
        style: [(e == null ? void 0 : e.style) || "", d !== void 0 ? `padding-left: ${d}px;` : ""]
      }), s(t.title), t.extra ? n(f, null, " ", s(t.extra)) : null), n("div", null, t.tmNodes.map((p) => j(p, i))));
    };
  }
});
export {
  G as NMenuOptionGroup,
  N as menuItemGroupProps
};
